module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_06@2x-65952e25a9fcb5a7b0d9558d1b2b6d4f.jpg";